import { getStartOfDayInTz } from '../../shared/utils/timezoneUtils/getStartOfDayInTz';
import { getEndOfDayInTz } from '../../shared/utils/timezoneUtils/getEndOfDayInTz';
import { getTimezoneOffset } from '../../shared/utils/timezoneUtils/getTimezoneOffset';
import { ChallengeImportantDatesFormValues } from '../interfaces/ChallengeFormValues';
import { ChallengeImportantDatesSection } from '../interfaces/SaveChallengeInfo';

const toStartOfDay = (date: string | null, tz: string) =>
  date ? getStartOfDayInTz(date, tz) : null;

const toEndOfDay = (date: string | null, tz: string) =>
  date ? getEndOfDayInTz(date, tz) : null;

/**
 * Converts challenge important dates from form values to API format.
 * Normalizes dates to start/end of day in the specified timezone and includes timezone offset.
 * @returns API-formatted dates object or null if timezone is missing
 */
export const convertDatesToApiFormat = (
  dates: ChallengeImportantDatesFormValues,
): ChallengeImportantDatesSection | null => {
  const { timeZone } = dates;

  if (!timeZone) {
    return null;
  }

  return {
    timeZone,
    offset: getTimezoneOffset(timeZone),
    startDate: toStartOfDay(dates.startDate, timeZone),
    endDate: toEndOfDay(dates.endDate, timeZone),
    registrationStartDate: toStartOfDay(dates.registrationStartDate, timeZone),
    registrationEndDate: toEndOfDay(dates.registrationEndDate, timeZone),
    firstScanStartDate: toStartOfDay(dates.firstScanStartDate, timeZone),
    firstScanEndDate: toEndOfDay(dates.firstScanEndDate, timeZone),
    lastScanStartDate: toStartOfDay(dates.lastScanStartDate, timeZone),
    lastScanEndDate: toEndOfDay(dates.lastScanEndDate, timeZone),
  };
};
